var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "agency-map" }, [
    _c("h2", { staticClass: "agency-map-title" }, [
      _vm._v(
        "\n        " + _vm._s(_vm.trans("labels.calculate_route")) + "\n    "
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "agency-map-container" }, [
      _c(
        "div",
        { staticClass: "search-and-map col-lg-12 p-0" },
        [
          _c(
            "div",
            { staticClass: "search-bar-container" },
            [
              _vm.geolocalization
                ? _c(
                    "div",
                    {
                      staticClass: "geolocalize",
                      on: { click: _vm.geolocalize }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: "/img/icons/map/gps.svg",
                          alt: "Geolocalization"
                        }
                      })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("address-autocomplete", {
                attrs: { "is-home": false },
                on: { input: _vm.routeTo }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "buttons" }, [
                _c("label", { attrs: { for: "car" } }, [
                  _c("img", {
                    staticClass: "ico_percorso",
                    attrs: {
                      src:
                        "/img/icons/map/car-" +
                        (_vm.current_type == "driving" ? "on" : "off") +
                        ".svg"
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.current_type,
                        expression: "current_type"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "car",
                      id: "car",
                      value: "driving"
                    },
                    domProps: { checked: _vm._q(_vm.current_type, "driving") },
                    on: {
                      change: [
                        function($event) {
                          _vm.current_type = "driving"
                        },
                        _vm.setType
                      ]
                    }
                  })
                ]),
                _vm._v(" "),
                _c("label", { attrs: { for: "man" } }, [
                  _c("img", {
                    staticClass: "ico_percorso",
                    attrs: {
                      src:
                        "/img/icons/map/man-" +
                        (_vm.current_type !== "driving" ? "on" : "off") +
                        ".svg"
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.current_type,
                        expression: "current_type"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "man",
                      id: "man",
                      value: "walking"
                    },
                    domProps: { checked: _vm._q(_vm.current_type, "walking") },
                    on: {
                      change: [
                        function($event) {
                          _vm.current_type = "walking"
                        },
                        _vm.setType
                      ]
                    }
                  })
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("tecno-map", {
            ref: "map",
            staticClass: "detail-map",
            attrs: { options: _vm.options, sector: _vm.sector }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm.last_result.actions && _vm.last_result.actions.length
      ? _c(
          "div",
          {
            ref: "actions_container",
            staticClass: "actions-container col-lg-12",
            attrs: { id: "actions_container" }
          },
          [
            _c("div", { staticClass: "info-street" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.trans("labels.route_directions")))
              ]),
              _vm._v(" "),
              _vm.last_result.actions && _vm.last_result.actions.length
                ? _c("div", { staticClass: "actions-buttons" }, [
                    _c(
                      "button",
                      { staticClass: "btn", on: { click: _vm.copy } },
                      [
                        _c("img", {
                          attrs: { src: "/img/icons/copy-agency.svg" }
                        }),
                        _vm._v(
                          _vm._s(_vm.lang.labels.copy) + "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      { staticClass: "btn", on: { click: _vm.print } },
                      [
                        _c("img", {
                          attrs: { src: "/img/icons/print-agency.svg" }
                        }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.lang.labels.print) +
                            "\n                "
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm._l(_vm.last_result.actions, function(action, index) {
              return _c("p", { key: index }, [
                _c("strong", [_vm._v(_vm._s(index + 1) + " .")]),
                _vm._v(" " + _vm._s(action) + "\n        ")
              ])
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }